import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { Stack } from '@mui/system'
import React from 'react'
import { ActuatorState } from '../../models/smart-home.model'
import { Box } from '@mui/material'

interface Props {
  state: ActuatorState
}

const ActuatorStateDisplay: React.FC<Props> = ({ state }) => {
  const stateColors: Record<ActuatorState, string> = {
    on: 'success.main',
    off: 'error.main',
    unknown: 'warning.main',
    group: 'grey.grey06',
  }

  return (
    <Stack flexDirection={'row'} alignItems={'center'} gap={1}>
      <Typography variant="h3" component={'span'}>
        {'smart-home.actuator-state.' + state}
      </Typography>
      <Box sx={{ width: 16, height: 16, borderRadius: 6, bgcolor: stateColors[state] }} />
    </Stack>
  )
}

export default ActuatorStateDisplay
